import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { ComponentStoreFactory } from '../../../../shared/store/common/component-store.factory';
import { PersonService } from '../../../service/person.service';
import { VoucherGridObject } from '@it2go/types';
import {
    selectCurrentServiceId,
    selectCurrentServiceSettings,
    selectIsFolderTerminated,
} from '../../../store/person/person.selectors';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import {
    SERVICE_SETTINGS_VOUCHER_TYPE_DEFAULT,
    SERVICE_SETTINGS_VOUCHER_TYPE_KEY,
} from '@libs/types/src/services/types/service-settings-voucher.type';

interface State {
    vouchers: VoucherGridObject | null,
}

const defaultState: State = {
    vouchers: null,
};

@Injectable()
export class VouchersPageStore extends ComponentStoreFactory<State, PersonService> {

    serviceId$ = this.globalStore!.select(selectCurrentServiceId);

    showNursingCare = toSignal(this.globalStore!.select(
        selectCurrentServiceSettings(SERVICE_SETTINGS_VOUCHER_TYPE_KEY, SERVICE_SETTINGS_VOUCHER_TYPE_DEFAULT),
    ).pipe(
        map((serviceSettings) => serviceSettings?.usePlanAndEvaluation ?? true),
    ));

    constructor() {
        super(defaultState, inject(Store), inject(PersonService));
    }

}
